import React, { useState } from "react";
import "../styles/Social.css";

const Social = () => {
  const [posts, setPosts] = useState([
    {
      id: 1,
      user_name: "Dr. Ana Silva",
      user_profile_pic: "https://randomuser.me/api/portraits/women/44.jpg",
      content: "Acabei de publicar um novo artigo sobre hipertensão em jovens adultos. Confira no link abaixo!",
      likes: 24,
      comments: 5,
      created_at: "2023-09-15T14:30:00Z",
      type: "professional"
    },
    {
      id: 2,
      user_name: "Clínica Saúde Total",
      user_profile_pic: "https://randomuser.me/api/portraits/lego/5.jpg",
      content: "Estamos com horários disponíveis para consultas de cardiologia e pneumologia na próxima semana! Agende pelo nosso site ou aplicativo.",
      likes: 8,
      comments: 2,
      created_at: "2023-09-14T09:15:00Z",
      type: "business"
    }
  ]);

  const [postContent, setPostContent] = useState("");
  const [commentingOn, setCommentingOn] = useState(null);
  const [commentText, setCommentText] = useState("");
  const [likedPosts, setLikedPosts] = useState([]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const handlePostSubmit = (e) => {
    e.preventDefault();
    if (!postContent.trim()) return;

    const newPost = {
      id: Date.now(),
      user_name: "Dr. Usuário",
      user_profile_pic: "https://randomuser.me/api/portraits/lego/1.jpg",
      content: postContent,
      likes: 0,
      comments: 0,
      created_at: new Date().toISOString(),
      type: "professional"
    };

    setPosts([newPost, ...posts]);
    setPostContent("");
  };

  const handleLike = (postId) => {
    if (likedPosts.includes(postId)) {
      // Unlike
      setLikedPosts(prev => prev.filter(id => id !== postId));
      setPosts(prev => prev.map(post => 
        post.id === postId ? {...post, likes: post.likes - 1} : post
      ));
    } else {
      // Like
      setLikedPosts(prev => [...prev, postId]);
      setPosts(prev => prev.map(post => 
        post.id === postId ? {...post, likes: post.likes + 1} : post
      ));
    }
  };

  const handleCommentClick = (postId) => {
    setCommentingOn(commentingOn === postId ? null : postId);
    setCommentText("");
  };

  const handleCommentSubmit = (postId, e) => {
    e.preventDefault();
    if (!commentText.trim()) return;

    // Add comment logic
    setPosts(prev => prev.map(post => 
      post.id === postId ? {...post, comments: post.comments + 1} : post
    ));
    setCommentText("");
    setCommentingOn(null);
  };

  return (
    <div className="social-container">
      <div className="social-header">
        <h2>Social</h2>
        <p>Compartilhe informações e interaja com outros profissionais de saúde e pacientes.</p>
      </div>

      <div className="post-form-container">
        <form className="post-form" onSubmit={handlePostSubmit}>
          <textarea
            placeholder="Compartilhe informações, artigos ou dicas médicas..."
            rows={3}
            value={postContent}
            onChange={(e) => setPostContent(e.target.value)}
          />
          <div className="form-actions">
            <button 
              type="submit" 
              className="post-button"
              disabled={!postContent.trim()}
            >
              Publicar
            </button>
          </div>
        </form>
      </div>

      <div className="posts-container">
        {posts.map(post => (
          <div key={post.id} className="post-card">
            <div className="post-header">
              <img 
                src={post.user_profile_pic} 
                alt={post.user_name}
                className="user-avatar" 
              />
              <div className="post-meta">
                <h3>{post.user_name}</h3>
                <div className="post-info">
                  <span className="post-type">
                    {post.type === 'professional' ? 'Profissional de saúde' : 'Negócio'}
                  </span>
                  <span className="post-date">{formatDate(post.created_at)}</span>
                </div>
              </div>
            </div>
            
            <div className="post-content">
              <p>{post.content}</p>
            </div>
            
            <div className="post-actions">
              <button 
                className={`like-button ${likedPosts.includes(post.id) ? 'liked' : ''}`}
                onClick={() => handleLike(post.id)}
              >
                {likedPosts.includes(post.id) ? '❤️' : '🤍'} <span>{post.likes}</span>
              </button>
              
              <button 
                className="comment-button"
                onClick={() => handleCommentClick(post.id)}
              >
                💬 <span>{post.comments}</span>
              </button>
            </div>
            
            <div className={`comment-input-area ${commentingOn === post.id ? 'visible' : ''}`}>
              <form className="comment-form" onSubmit={(e) => handleCommentSubmit(post.id, e)}>
                <input
                  type="text"
                  className="comment-input"
                  placeholder="Escreva um comentário..."
                  value={commentText}
                  onChange={(e) => setCommentText(e.target.value)}
                />
                <button type="submit" className="comment-submit">Enviar</button>
              </form>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Social;